import React, { Component } from "react";
import TakeOverComponent from "./TakeOverComponent";
import {
    CATEGORY_LIST,
    MENU_LIST,
    DELETE_CART,
    ADD_TO_CART,
    REMOVE_FROM_CART,
    PLACE_ORDER,
    MISC,
    OFFERS_LIST,
} from "../../Network/ApiPaths";
import Uri from "../../Network/Uri";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";

class TakeOverContainer extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        const access = JSON.parse(
            window.localStorage.getItem("access") || "null"
        );
        const client = JSON.parse(
            window.localStorage.getItem("clientAccess") || "null"
        );
        this.storeDet = access;
        this.storeFresh = client;
        this.storeIdValue =
            client?.storeId || access?.storeId || "";
        this.storeUserId = access?.userId || "";
        this.clientHost = client?.host || "";
        this.storeName =
            client?.storeName || access?.storeName || "";
        this.storeAddress = access?.address || "";
        this.gst = access?.gst || "";
        this.state = {
            catSelected: false,
            proSelected: false,
            catId: "",
            addonStatus: "",
            product: null,
            customer: null,
            offer: null,
            offerId: "",
            radio: "",
            measure: "",
            categories: [],
            products: [],
            filteredProducts: [],
            selectedCatProducts: [],
            priceID: "",
            cart: [],
            addOns: [],
            selectedAddons: [],
            itemNumber: "1",
            cartPrice: {},
            pay: "",
            orderPlaced: false,
            orderVerified: false,
            creatingOrder: false,
            showPrintPreview: false,
            date: "",
            finalId: "",
            orderedItems: [],
            mobile: "",
            amount: "",
            change: "",
            bill_no: 0,
            totalOrders: 0,
            totalSales: 0,
            netSales: 0,
            average: 0,
            offers: [],
            search: true,
            searchValue: "",
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.getDate();
        this.tillOrders();
        this.getCategories();
        this.getProducts();
        this.getAddons();
        this.getOrderDetails();
        this.getOffers();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    setStateSafe = (state, callback) => {
        if (this._isMounted) {
            this.setState(state, callback);
        }
    };
    /* =====================================================
       DATE
    ===================================================== */
    getDate = () => {
        let date = new Date().toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        date = date.replace(",", "").replace(/\//g, "-");
        this.setStateSafe({
            date,
        });
    };
    /* =====================================================
       CATEGORIES
    ===================================================== */
    getCategories = () => {
        if (!this.storeFresh || !this.clientHost) {
            console.log("clientAccess not found");
            return;
        }
        const apiPath = new Uri(
            this.clientHost + CATEGORY_LIST
        )
            .addQueryParam(
                "store_id",
                this.storeFresh.storeId
            )
            .addQueryParam("offset", 0)
            .addQueryParam("limit", 1000);
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (onSuccessResponse) => {
                console.log(
                    "CATEGORIES FOR KOT:",
                    onSuccessResponse.result
                );
                this.setState({
                    categories:
                        onSuccessResponse.result || [],
                });
            },
            (onError) => {
                console.log(
                    "CATEGORY API ERROR:",
                    onError.message
                );
            }
        );
    };
    /* =====================================================
       PRODUCTS
    ===================================================== */
    getProducts = () => {
        getResponseClient(
            new Uri(this.clientHost + MENU_LIST),
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                const products = response.result || [];
                this.setState({
                    products,
                    filteredProducts: products,
                });
            },
            (error) => {
                console.log("PRODUCT API ERROR:", error);
            }
        );
    };
    /* =====================================================
       ADDONS
    ===================================================== */
    getAddons = () => {
        const apiPath = new Uri(
            this.clientHost +
            `addon/addonsByStore?storeId=${this.storeIdValue}`
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                this.setState({
                    addOns: response.result || [],
                });
            },
            (error) => {
                console.log("ADDON API ERROR:", error);
            }
        );
    };
    /* =====================================================
       OFFERS
    ===================================================== */
    getOffers = () => {
        const apiPath = new Uri(
            this.clientHost + OFFERS_LIST
        ).addQueryParam(
            "storeid",
            this.storeIdValue
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                this.setState({
                    offers: response.result || [],
                });
            },
            (error) => {
                console.log("OFFERS API ERROR:", error);
            }
        );
    };
    /* =====================================================
       SEARCH
    ===================================================== */
    searchInitiate = (value) => {
        this.setState({
            searchValue: value,
        });
        this.onSearch(value);
    };
    onSearch = (value) => {
        const products = this.state.products || [];
        if (!value.trim()) {
            // If search is empty, show selected category again
            const filteredProducts =
                this.state.catSelected &&
                    this.state.selectedCatProducts.length > 0
                    ? this.state.selectedCatProducts
                    : products;
            this.setState({
                filteredProducts,
            });
            return;
        }
        // When typing, search ALL products
        const filtered = products.filter((product) =>
            (product.info?.name || "")
                .toLowerCase()
                .includes(value.toLowerCase())
        );

        this.setState({
            filteredProducts: filtered,
        });
    };
    /* =====================================================
       CATEGORY
    ===================================================== */
    onCat = (category) => {
        const products = this.state.products || [];
        const filteredProducts = products.filter(
            (product) =>
                String(product.info?.category_id) ===
                String(category.id)
        );
        this.setState({
            selectedCatProducts: filteredProducts,
            filteredProducts,
            catSelected: true,
            catId: category.id,
            addonStatus: category.addon_status,
            searchValue: "",
        });
    };
    /* =====================================================
       PRODUCT
    ===================================================== */
    onProduct = (product) => {
        if (product.prices?.length > 1) {
            if (this.state.priceID !== "") {
                this.setState({
                    product,
                });
            } else {
                alert("select price");
            }
        } else {
            this.setState({
                product,
            });
        }
    };
    /* =====================================================
       PRICE
    ===================================================== */
    onRadioChanged = (price) => {
        this.setState({
            priceID: price.id,
            measure: price.measure,
        });
    };
    /* =====================================================
       QUANTITY
    ===================================================== */
    numberOfItems = (event) => {
        this.setState({
            itemNumber: event.target.value.toString(),
        });
    };
    /* =====================================================
       ADD TO CART
    ===================================================== */
    addToCart = (product) => {
        if (
            this.state.priceID === "" &&
            product.prices?.length > 1
        ) {
            alert("select price");
            return;
        }
        const priceId =
            product.prices?.length > 1
                ? this.state.priceID
                : product.prices?.map((p) => p.id).toString();
        const requestBody = {
            quantity: this.state.itemNumber,
            price_id: priceId,
            user_id: this.storeUserId,
            product_id: product.info.id,
        };
        postClientDataResponse(
            this.clientHost + ADD_TO_CART,
            this.storeFresh.key,
            requestBody,
            () => {
                this.setState({
                    proSelected: true,
                    product: null,
                    selectedAddons: [],
                    itemNumber: "1",
                    priceID: "",
                    measure: "",
                    orderPlaced: false,
                    orderVerified: false,
                });
                this.getCart();
            },
            (error) => {
                console.log("ADD CART ERROR:", error);
            }
        );
    };
    /* =====================================================
       GET CART
    ===================================================== */
    getCart = () => {
        const cartApi = new Uri(
            this.clientHost +
            `Cart/userCartItems?offset=0&user_id=${this.storeUserId}&limit=100`
        );
        getResponseClient(
            cartApi,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                this.setState({
                    cart: response.result || [],
                    pay: "",
                });
            },
            (error) => {
                console.log("CART ERROR:", error);
            }
        );
        const priceApi = new Uri(
            this.clientHost +
            `Cart/cartPrice?userid=${this.storeUserId}`
        );
        getResponseClient(
            priceApi,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                this.setState({
                    cartPrice: response.result || {},
                });
            },
            (error) => {
                console.log("CART PRICE ERROR:", error);
            }
        );
    };
    /* =====================================================
       REMOVE CART
    ===================================================== */
    removeFromCart = (item) => {
        const apiPath = new Uri(
            this.clientHost + REMOVE_FROM_CART
        ).addQueryParam("id", item.id);
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            () => {
                this.getCart();
            },
            (error) => {
                console.log("REMOVE CART ERROR:", error);
            }
        );
    };
    /* =====================================================
       DELETE CART
    ===================================================== */
    deleteCart = () => {
        const apiPath = new Uri(
            this.clientHost + DELETE_CART
        ).addQueryParam(
            "userid",
            this.storeUserId
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            () => {
                this.getCart();
            },
            (error) => {
                console.log("DELETE CART ERROR:", error);
            }
        );
    };
    /* =====================================================
       PAYMENT
    ===================================================== */
    onPaytype = (event) => {
        const payment = event.target.value;
        console.log("PAYMENT SELECTED:", payment);
        this.setState({
            pay: payment,
        });
    };
    onFieldChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };
    /* =====================================================
       VERIFY
       IMPORTANT:
       THIS DOES NOT CREATE ORDER.
    ===================================================== */
    onOrderVerify = () => {
        const payment = this.state.pay;
        console.log("PAYMENT WHEN VERIFY CLICKED:", payment);
        console.log("FULL STATE:", this.state);
        if (!payment) {
            alert("Select payment");
            return;
        }
        if (
            payment === "cash" &&
            !this.state.amount
        ) {
            alert("Enter amount");
            return;
        }
        this.getDate();
        this.setState({
            orderVerified: true,
            orderPlaced: false,
            showPrintPreview: true,
        });
    };
    /* =====================================================
       PRINT CALLBACK
       react-to-print calls this AFTER browser print dialog
       closes.
       ONLY NOW create the order.
    ===================================================== */
    handlePrintAfterBrowserPrint = () => {
        console.log(
            "Browser print completed/closed."
        );
        if (!this.state.orderVerified) {
            return;
        }
        if (
            this.state.orderPlaced ||
            this.state.creatingOrder
        ) {
            return;
        }
        this.createOrder();
    };
    /* =====================================================
       CREATE ORDER
    ===================================================== */
    createOrder = () => {
        const payment = this.state.pay;
        if (
            this.state.orderPlaced ||
            this.state.creatingOrder
        ) {
            return;
        }
        if (!payment) {
            alert("Select payment");
            return;
        }
        if (
            payment === "cash" &&
            !this.state.amount
        ) {
            alert("Enter amount");
            return;
        }
        if (
            payment === "cash" &&
            Number(this.state.amount) <
            Number(this.state.cartPrice?.cartTotal || 0)
        ) {
            alert("Received amount is less than bill amount");
            return;
        }
        if (payment === "cash") {
            this.placeCashOrder();
        } else if (payment === "online") {
            this.placeOnlineOrder();
        } else if (payment === "swipe") {
            this.placeSwipeOrder();
        }
    };
    /* =====================================================
       CASH ORDER
    ===================================================== */
    placeCashOrder = () => {
        this.setState({
            creatingOrder: true,
        });
        const total = Number(
            this.state.cartPrice?.cartTotal || 0
        );
        const received = Number(
            this.state.amount || 0
        );
        const requestBody = {
            userId: this.storeUserId,
            storeId: this.storeIdValue,
            shipping_address: this.storeName,
            payment_mode: "COD",
            payment_status: "PAID_BY_COD",
            paytm_ref_id: "cod_90",
            platform: "POS",
            landmark: "PG",
            address_lat:
                this.storeDet?.latitute || "",
            address_lng:
                this.storeDet?.longitude || "",
            order_status: "4",
            offer_amount:
                this.state.cartPrice?.offer_amount,
            offer_percentage:
                this.state.cartPrice?.offer_percentage,
            offerId: this.state.offerId,
            customer_phone:
                this.state.mobile,
            cash_received: this.state.amount,
            cash_balance:
                received - total,
            bill_no:
                Number(this.state.bill_no) + 1,
        };
        this.sendOrder(requestBody);
    };
    /* =====================================================
       ONLINE ORDER
    ===================================================== */
    placeOnlineOrder = () => {
        this.setState({
            creatingOrder: true,
        });
        const requestBody = {
            userId: this.storeUserId,
            storeId: this.storeIdValue,
            shipping_address: this.storeName,
            payment_mode: "ONLINE",
            payment_status: "PAID_BY_PAYTM",
            platform: "POS",
            online_ref_id: "online_90",
            landmark: "PG",
            address_lat:
                this.storeDet?.latitute || "",
            address_lng:
                this.storeDet?.longitude || "",
            order_status: "4",
            offer_amount:
                this.state.cartPrice?.offer_amount,
            offer_percentage:
                this.state.cartPrice?.offer_percentage,
            offerId: this.state.offerId,
            customer_phone:
                this.state.mobile,
            cash_received: "",
            cash_balance: "0.0",
            items: JSON.stringify(
                this.state.cart
            ),
            bill_no:
                Number(this.state.bill_no) + 1,
        };
        this.sendOrder(requestBody);
    };
    /* =====================================================
       SWIPE ORDER
    ===================================================== */
    placeSwipeOrder = () => {
        this.setState({
            creatingOrder: true,
        });
        const requestBody = {
            userId: this.storeUserId,
            storeId: this.storeIdValue,
            shipping_address: this.storeName,
            payment_mode: "CARD",
            payment_status: "PAID_BY_MACHINE",
            online_ref_id: "",
            platform: "POS",
            landmark: "PG",
            address_lat:
                this.storeDet?.latitute || "",
            address_lng:
                this.storeDet?.longitude || "",
            order_status: "4",
            offer_amount:
                this.state.cartPrice?.offer_amount,
            offer_percentage:
                this.state.cartPrice?.offer_percentage,
            offerId: this.state.offerId,
            customer_phone:
                this.state.mobile,
            cash_received: "",
            cash_balance: "0.0",
            bill_no:
                Number(this.state.bill_no) + 1,
        };
        this.sendOrder(requestBody);
    };
    /* =====================================================
       COMMON ORDER API
    ===================================================== */
    sendOrder = (requestBody) => {
        postClientDataResponse(
            this.clientHost + PLACE_ORDER,
            this.storeFresh.key,
            requestBody,

            (response) => {
                if (!this._isMounted) return;

                const orderId = response?.data?.result;

                console.log("ORDER CREATED:", orderId);

                // Order successfully created
                this.setState(
                    {
                        orderPlaced: true,
                        creatingOrder: false,
                        finalId: orderId,
                    },
                    () => {
                        this.tillOrders();

                        // Clear backend cart and then reset screen
                        this.clearCartAfterOrder();
                    }
                );
            },

            (error) => {
                console.log("ORDER CREATION FAILED:", error);

                if (!this._isMounted) return;

                this.setState({
                    creatingOrder: false,
                });

                alert("Order creation failed");
            }
        );
    };
    resetOrderScreen = () => {
        console.log("RESETTING TAKE OVER SCREEN");

        this.setState(
            {
                catSelected: false,
                proSelected: false,

                catId: "",
                addonStatus: "",

                product: null,
                customer: null,

                offer: null,
                offerId: "",

                radio: "",
                measure: "",
                priceID: "",

                cart: [],
                selectedAddons: [],

                itemNumber: "1",

                cartPrice: {},

                pay: "",

                orderPlaced: false,
                orderVerified: false,
                creatingOrder: false,

                showPrintPreview: false,

                finalId: "",
                orderedItems: [],

                mobile: "",
                amount: "",
                change: "",

                searchValue: "",

                selectedCatProducts: [],

                filteredProducts: this.state.products || [],
            },

            () => {
                console.log("TAKE OVER SCREEN RESET DONE");

                // Confirm backend cart is empty
                this.getCart();
            }
        );
    };

    /* =====================================================
       CLEAR CART + RESET SCREEN
    ===================================================== */

    clearCartAfterOrder = () => {
        const apiPath = new Uri(
            this.clientHost + DELETE_CART
        ).addQueryParam(
            "userid",
            this.storeUserId
        );

        console.log("CLEARING CART AFTER SUCCESSFUL ORDER...");

        getResponseClient(
            apiPath,
            this.storeFresh.key,

            (response) => {
                console.log("DELETE CART SUCCESS:", response);

                if (!this._isMounted) return;

                // Reset screen after cart is cleared
                this.resetOrderScreen();
            },

            (error) => {
                console.log("DELETE CART ERROR:", error);

                /*
                 * Order was already created successfully.
                 * Reset the UI even if DELETE_CART fails.
                 */
                if (!this._isMounted) return;

                this.resetOrderScreen();
            }
        );
    };

    /* =====================================================
       RESET POS SCREEN
    ===================================================== */

    resetOrderScreen = () => {
        console.log("RESETTING POS SCREEN...");

        this.setState(
            {
                catSelected: false,
                proSelected: false,

                catId: "",
                addonStatus: "",

                product: null,
                customer: null,

                offer: null,
                offerId: "",

                radio: "",
                measure: "",
                priceID: "",

                cart: [],
                selectedAddons: [],

                itemNumber: "1",

                cartPrice: {},

                pay: "",

                orderPlaced: false,
                orderVerified: false,
                creatingOrder: false,

                showPrintPreview: false,

                finalId: "",
                orderedItems: [],

                mobile: "",
                amount: "",
                change: "",

                searchValue: "",

                filteredProducts: this.state.products || [],
                selectedCatProducts: [],
            },

            () => {
                console.log("=================================");
                console.log("POS SCREEN RESET COMPLETE");
                console.log("CART:", this.state.cart);
                console.log("PAYMENT:", this.state.pay);
                console.log("AMOUNT:", this.state.amount);
                console.log("PRODUCT:", this.state.product);
                console.log("PRINT PREVIEW:", this.state.showPrintPreview);
                console.log("=================================");

                // Make sure frontend gets the latest backend cart
                this.getCart();
            }
        );
    };
    /* =====================================================
       GET ORDER ITEMS
    ===================================================== */
    getItems = () => {
        const apiPath = new Uri(
            this.clientHost +
            `Order/getOrderItems?order_id=${this.state.finalId}`
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                this.setState({
                    orderedItems:
                        response.result || [],
                });
            },
            (error) => {
                console.log(
                    "ORDER ITEMS ERROR:",
                    error
                );
            }
        );
    };
    /* =====================================================
       TODAY ORDER COUNT
    ===================================================== */
    getOrderDetails = () => {
        const apiPath = new Uri(
            this.clientHost +
            "Report/getTodaySalesCount"
        ).addQueryParam(
            "storeId",
            this.storeIdValue
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                const result =
                    response.response || [];
                if (result.length > 0) {
                    const item = result[0];
                    this.setState({
                        totalOrders: item.OrdersCount,
                        totalSales: item.TotalAmount,
                        netSales: item.NetSale,
                        average: item.Average,
                    });
                }
            },
            (error) => {
                console.log(
                    "ORDER COUNT ERROR:",
                    error
                );
            }
        );
    };
    /* =====================================================
       BILL NUMBER
    ===================================================== */
    tillOrders = () => {
        const apiPath = new Uri(
            this.clientHost + MISC
        ).addQueryParam(
            "store_id",
            this.storeFresh.storeId
        );
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;
                const orders =
                    response.response || [];
                const order =
                    orders.find(
                        (item) =>
                            item.range === "Orders" &&
                            String(item.store_id) ===
                            String(this.storeFresh.storeId)
                    );
                if (order) {
                    this.setState({
                        bill_no: Number(
                            order.OrdersCount || 0
                        ),
                    });
                }
            },
            (error) => {
                console.log(
                    "TILL ORDER ERROR:",
                    error
                );
            }
        );
    };
    /* =====================================================
       ADDON
    ===================================================== */
    handleAddon = (addon) => {
        const price =
            this.state.measure === "Regular"
                ? addon.price_regular
                : addon.price_medium;
        const selected = {
            name: addon.name,
            id: addon.id,
            price,
            quantity: this.state.itemNumber,
        };
        this.setState({
            selectedAddons: [
                ...this.state.selectedAddons,
                selected,
            ],
        });
    };
    checkAddons = (product) => {
        if (
            this.state.selectedAddons.length === 0
        ) {
            this.addToCart(product);
            return;
        }
        this.addWithAddons(product);
    };
    addWithAddons = (product) => {
        const priceId =
            product.prices?.length > 1
                ? this.state.priceID
                : product.prices?.map(
                    (p) => p.id
                ).toString();
        const requestBody = {
            quantity: this.state.itemNumber,
            price_id: priceId,
            user_id: this.storeUserId,
            product_id: product.info.id,
            addons: JSON.stringify(
                this.state.selectedAddons
            ),
        };
        postClientDataResponse(
            this.clientHost + ADD_TO_CART,
            this.storeFresh.key,
            requestBody,
            () => {
                this.setState({
                    proSelected: true,
                    product: null,
                    selectedAddons: [],
                    itemNumber: "1",
                    priceID: "",
                    measure: "",
                });
                this.getCart();
            },
            (error) => {
                console.log(
                    "ADDON CART ERROR:",
                    error
                );
            }
        );
    };
    /* =====================================================
       OFFER
    ===================================================== */
    onOffer = () => {
        this.setState({
            offer: "p",
        });
    };
    onOfferTrigger = (offer) => {
        this.setState({
            offerId: offer.id,
        });
    };
    onhandleOffer = () => {
        const apiPath = new Uri(
            this.clientHost +
            `Cart/cartPrice?userid=${this.storeUserId}&offerId=${this.state.offerId}`
        );
        this.setState({
            offer: null,
        });
        getResponseClient(
            apiPath,
            this.storeFresh.key,
            (response) => {
                if (!this._isMounted) return;

                this.setState({
                    cartPrice: response.result,
                });
            },
            (error) => {
                console.log(
                    "OFFER ERROR:",
                    error
                );
            }
        );
    };
    /* =====================================================
       MODAL
    ===================================================== */
    closeModal = () => {
        this.setState({
            product: null,
            offer: null,
        });
    };
    /* =====================================================
       UI STYLES
    ===================================================== */
    getStyles = () => ({
        margin: {
            margin: "0 5px",
            color: "#000",
            display: "inline",
        },
        marginAll10: {
            margin: "10px",
            width: "20px",
            height: "20px",
        },
        imgSmall: {
            margin: "0 10px 0 20px",
            width: "30px",
            height: "30px",
        },
        imageMenu: {
            margin: "0 0 0 10px",
            width: "40px",
            height: "40px",
        },
        green: {
            color: "#008000",
        },
        red: {
            color: "#FF0000",
        },
        tdCart: {
            width: "150px",
            padding: "5px",
        },
        tdCartLarge: {
            width: "200px",
            padding: "5px",
        },
        tdSmall: {
            width: "40px",
            padding: "5px",
        },
    });
    render() {
        let totalPrice = 0;
        if (this.state.cartPrice) {
            totalPrice =
                Number(
                    this.state.cartPrice.itemsTotal || 0
                ) +
                Number(
                    this.state.cartPrice.addonTotal || 0
                );
        }
        return (
            <TakeOverComponent
                state={this.state}
                categories={this.state.categories}
                storeName={this.storeName}
                storeAddress={this.storeAddress}
                gst={this.gst}
                onCat={this.onCat}
                searchInitiate={this.searchInitiate}
                onRadioChanged={this.onRadioChanged}
                numberOfItems={this.numberOfItems}
                addToCart={this.addToCart}
                onProduct={this.onProduct}
                getCart={this.getCart}
                deleteCart={this.deleteCart}
                onPaytype={this.onPaytype}
                onOffer={this.onOffer}
                onOrderVerify={this.onOrderVerify}
                handlePrintAfterBrowserPrint={
                    this.handlePrintAfterBrowserPrint
                }
                removeFromCart={this.removeFromCart}
                onFieldChange={this.onFieldChange}
                product={this.state.product}
                offer={this.state.offer}
                closeModal={this.closeModal}
                addons={this.state.addOns}
                handleAddon={this.handleAddon}
                checkAddons={this.checkAddons}
                onhandleOffer={this.onhandleOffer}
                onOfferTrigger={this.onOfferTrigger}
                styles={this.getStyles()}
                totalPrice={totalPrice}
            />
        );
    }
}
export default TakeOverContainer;
